import { RootState } from "@/store/types";
import { Getter, GetterTree } from "vuex";
import { ParametresState } from "./type";


export const getLastSynchro: Getter<ParametresState, RootState> = state => state.lastSync;
export const getMobiVersion: Getter<ParametresState, RootState> = state => state.mobiVersion;

export const getLocalPointagesFalse: Getter<ParametresState, RootState> = state => state.localPointagesfalse;
export const getRemotePointagesFalse: Getter<ParametresState, RootState> = state => state.remotePointagesfalse;

export const getLocalSupplementsFalse: Getter<ParametresState, RootState> = state => state.localSupplementsfalse;
export const getRemoteSupplementsFalse: Getter<ParametresState, RootState> = state => state.remoteSupplementsfalse;

export const getLocalPointagesFalseOthers: Getter<ParametresState, RootState> = state => state.localPointagesfalseOthers;
export const getRemotePointagesFalseOthers: Getter<ParametresState, RootState> = state => state.remotePointagesfalseOthers;
export const getRemotePointagesTrueOthers: Getter<ParametresState, RootState> = state => state.remotePointagesTrueOthers;

export const getLocalSupplementsFalseOthers: Getter<ParametresState, RootState> = state => state.localSupplementsfalseOthers;
export const getRemoteSupplementsFalseOthers: Getter<ParametresState, RootState> = state => state.remoteSupplementsfalseOthers;
export const getRemoteSupplementsTrueOthers: Getter<ParametresState, RootState> = state => state.remoteSupplementsTrueOthers;
export const getUpgrade: Getter<ParametresState, RootState> = state => state.upgrade;

export const getters: GetterTree<ParametresState, RootState> = {
    getLastSynchro,
    getMobiVersion,
    getLocalPointagesFalse,
    getRemotePointagesFalse,
    getLocalSupplementsFalse,
    getRemoteSupplementsFalse,
    getLocalPointagesFalseOthers,
    getRemotePointagesFalseOthers,
    getRemotePointagesTrueOthers,
    getLocalSupplementsFalseOthers,
    getRemoteSupplementsFalseOthers,
    getRemoteSupplementsTrueOthers,
    getUpgrade
}
